"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
import GridSelector from "@/components/dialog/GridSelector.vue";
const DepartmentSelector = () => import("@/components/dialog/GridSelector.vue");
import API from "@ym-framework/api-utils";
import _ from "lodash";
let TOTPBlackListDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.shopName = null;
    this.totpName = null;
    this.createShop = true;
    this.formController = {
      "type": "user",
      "datas": [],
      "ids": []
    };
    this.byMembersController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    this.byMemberselectDatas = [];
    this.byDepartmentselectDatas = [];
    this.departmentList = [];
    this.activeName = "first";
    this.searchStrbyMember = "";
    this.searchStrbyDepartment = "";
    this.departmentProps = {
      label: "label",
      children: "children"
    };
    this.byMemberselectLock = false;
    this.byDepartmentselectLock = false;
  }
  created() {
    return __async(this, null, function* () {
      this.byMembersController.on("searched", (item) => {
        this.byMembercheckItem();
      });
      this.byMembersController.pagePosition = "dialog";
      this.byMembersController.size = true;
      this.byMembersController.query.filter = `userStatus=='0'`;
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      try {
        this.byMemberselectDatas = [];
        this.byMemberselectLock = false;
        this.byDepartmentselectDatas = [];
        this.byDepartmentselectLock = false;
        this.byMembersController.query.size = 10;
        this.byMembersController.query.current = 1;
        this.searchStrbyMember = "";
        this.searchStrbyDepartment = "";
        this.dialog.visible = true;
        this.shopName = null;
        this.totpName = null;
        this.$nextTick(() => __async(this, null, function* () {
          try {
            if (item && item !== null && item !== "") {
              this.createShop = false;
              this.shopName = item.name;
              this.totpName = item.totp_data.totp_name;
              if (item.blacklist !== null && item.blacklist !== void 0) {
                this.formController = item.blacklist;
                if (this.formController.type === "user") {
                  yield this.byMembersearchByName(null);
                  if (this.formController.datas.length > 0) {
                    this.byMemberselectDatas = this.formController.datas;
                    for (let member of this.byMemberselectDatas) {
                      if (member.hasOwnProperty("label")) {
                        const _item = {
                          "id": member.id,
                          "label": member.label
                        };
                        this._byMembersGridSelector.add(_item);
                      } else {
                        const _item = {
                          "id": member.id,
                          "label": member.name
                        };
                        this._byMembersGridSelector.add(_item);
                      }
                    }
                    for (let data of this.formController.datas) {
                      let item2 = _.find(this.byMembersController.result.datas, {
                        shopId: data.id
                      });
                      if (item2 !== void 0) {
                        this._byMembersTable.toggleRowSelection(item2, true);
                      }
                    }
                  }
                }
                if (this.formController.type === "department") {
                  yield this.getDepartmentTrees();
                  if (this.formController.datas.length > 0) {
                    this.byDepartmentselectDatas = this.formController.datas;
                    for (let data of this.formController.datas) {
                      this._departmentTree.setChecked(data.id, true);
                    }
                  }
                }
              } else {
                yield this.byMembersearchByName(null);
              }
            } else {
              this.createShop = true;
              yield this.byMembersearchByName(null);
            }
          } catch (error) {
          }
        }));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  byMembercheckItem() {
    var _a;
    let selectDatas = (_a = this._byMembersGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.byMembersController.result.datas,
      selectDatas,
      (selectData, data) => selectData.guid == data.id
    );
    this.byMemberselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._byMembersTable.toggleRowSelection(row, true);
      }
    }
    this.byMemberselectLock = false;
  }
  changeChoice(mode) {
    return __async(this, null, function* () {
      try {
        this.formController.type = mode;
        this.formController.datas = [];
        if (mode === "user") {
          this.byMembersController.query.sort = "asc";
          this.byMembersController.query.filter = `userStatus=='0'`;
          this.byMembersController.search();
        }
        if (mode === "department") {
          yield this.getDepartmentTrees();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartmentTrees() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        let response = yield API.get(`api://base.auth/api/v7/departments`);
        arr.push(response.data);
        this.departmentList = arr;
        this.byDepartmentcheckItem();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  filterNode(value, data) {
    if (!value)
      return true;
    return data.label.indexOf(value) !== -1;
  }
  byDepartmentChanged(data) {
    if (data && data.length > 0) {
      let rows = _.differenceWith(
        this.byDepartmentselectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      this.byDepartmentselectLock = true;
      if (rows) {
        for (const row of rows) {
          let item = this.byDepartmentselectDatas.find(function(value) {
            return value.id === row.id;
          });
          this._departmentTree.setChecked(row.id, false);
        }
      }
      this.byDepartmentselectLock = false;
    } else {
      this.byDepartmentselectDatas = [];
      let checkedIds = this._departmentTree.getCheckedKeys();
      for (const id of checkedIds) {
        this._departmentTree.setChecked(id, false);
      }
    }
  }
  byMemberselectItems(items) {
    this.byMemberselectDatas = items;
    if (!this.byMemberselectLock) {
      let unSelectData = _.differenceWith(
        this.byMembersController.result.datas,
        items,
        _.isEqual
      );
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._byMembersGridSelector.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._byMembersGridSelector.del(_item);
      }
    }
  }
  byMemberChanged(data) {
    let rows = _.differenceWith(
      this.byMemberselectDatas,
      data,
      (selectData, data2) => selectData.guid == data2.id
    );
    this.byMemberselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._byMembersTable.toggleRowSelection(row, false);
      }
    }
    this.byMemberselectLock = false;
  }
  confirm(datas) {
    try {
      if (this.formController.type === "user") {
        let arr = [];
        let ids = [];
        for (let item of datas) {
          let data = {
            id: item.id,
            name: item.label
          };
          arr.push(data);
          ids.push(item.id);
        }
        this.formController.datas = arr;
        this.formController.ids = ids;
        this.$emit("chooseBlackListComplete", this.formController);
        this.cancel();
      }
      if (this.formController.type === "department") {
        let arr = [];
        let ids = [];
        for (let item of datas) {
          let data = {
            id: item.id,
            name: item.label
          };
          arr.push(data);
          ids.push(item.id);
        }
        this.formController.datas = arr;
        this.formController.ids = ids;
        this.$emit("chooseBlackListComplete", this.formController);
        this.cancel();
      }
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //切换树形框架选择器
  handleCheckChange(data, isChecked) {
    if (isChecked) {
      this.byDepartmentselectDatas.push(data);
      let new_data = {
        id: data.id,
        label: data.label
      };
      this._byDepartmentsGridSelector.add(new_data);
    } else {
      let item = this.byDepartmentselectDatas.find(function(value) {
        return value.id === data.id;
      });
      if (item) {
        let new_data = {
          id: item.id,
          label: item.label
        };
        this.byDepartmentselectDatas.splice(item, 1);
        this._byDepartmentsGridSelector.del(new_data);
      }
    }
  }
  cancel() {
    this.dialog.visible = false;
    this.searchStrbyMember = "";
    this.searchStrbyDepartment = "";
    this.formController = {
      "type": "user",
      "datas": [],
      "ids": []
    };
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
  byDepartmentcheckItem() {
    var _a;
    let selectDatas = (_a = this._byDepartmentsGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.departmentList,
      selectDatas,
      (selectData, data) => selectData.id == data.id
    );
    this.byDepartmentselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._departmentTree.setChecked(row.id, true);
      }
    }
    this.byDepartmentselectLock = false;
  }
  byDepartmentSearchName(searchStr) {
    return __async(this, null, function* () {
      this._departmentTree.filter(searchStr);
    });
  }
  byMembersearchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.byMembersController.query.filter = `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.byMembersController.query.filter = `userStatus=='0'`;
      }
      this.byMembersController.query.current = 1;
      yield this.byMembersController.search();
    });
  }
};
__decorateClass([
  Ref("byMembersTable")
], TOTPBlackListDialog.prototype, "_byMembersTable", 2);
__decorateClass([
  Ref("byMembersGridSelector")
], TOTPBlackListDialog.prototype, "_byMembersGridSelector", 2);
__decorateClass([
  Ref("department-tree")
], TOTPBlackListDialog.prototype, "_departmentTree", 2);
__decorateClass([
  Ref("byDepartmentsGridSelector")
], TOTPBlackListDialog.prototype, "_byDepartmentsGridSelector", 2);
__decorateClass([
  Debounce(500)
], TOTPBlackListDialog.prototype, "byMembersearchByName", 1);
TOTPBlackListDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog,
      GridSelector,
      DepartmentSelector
    }
  })
], TOTPBlackListDialog);
export {
  TOTPBlackListDialog as default
};
